import React, { FC, Fragment, useEffect, useState } from 'react';
import cls from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { INFT } from '../../../types/nft';
import { SwipableContainer } from '../..';
import { getApprovals } from '../../../ducks/nft/selectors';
import { checkApprovals, makeApproval, storeApproval } from '../../../ducks/nft/actions';
import { useWeb3React } from '@web3-react/core';
import { selectSelectedNFTs } from '../../../ducks/app/selectors';
import { SKCard } from '../Card';

interface INFTSwapContainer {
  NFTs: INFT[];
  convertToGridOnXL?: boolean;
  isTransferring?: boolean;
}

export const NFTSwapContainer: FC<INFTSwapContainer> = ({ NFTs, isTransferring }) => {
  // Allow queuing transaction, disable approve button depending on the contract address only
  const [approveDisabledPerAddress, setApproveDisabledPerAddress] = useState<{ [address: string]: boolean }>({});
  const selectedNFTs = useSelector(selectSelectedNFTs);
  const approvals = useSelector(getApprovals);
  const dispatch = useDispatch();
  const { library, account, chainId } = useWeb3React();
  const signer = library.getSigner(account);

  const onApprovalClick = (tokenAddress: string): void => {
    setApproveDisabledPerAddress({ ...approveDisabledPerAddress, [tokenAddress]: true });
    const signer = library.getSigner(account);
    dispatch(
      makeApproval(signer, tokenAddress, chainId || 1, (success) => {
        setApproveDisabledPerAddress({ ...approveDisabledPerAddress, [tokenAddress]: false });
        if (success) {
          dispatch(storeApproval({ address: tokenAddress, isApproved: success }));
        }
      }),
    );
  };

  useEffect(() => {
    dispatch(checkApprovals(signer, chainId || 1));
  }, []);

  return (
    <SwipableContainer className={cls('flex flex-wrap gap-2', { 'justify-center': NFTs.length <= 1 })}>
      {NFTs.length ? (
        NFTs.map((NFT, index) => {
          return (
            <Fragment key={index}>
              <SKCard
                size="md"
                selectable={false}
                selected={false}
                nft={NFT}
                approveButton={{
                  isDisabled: approveDisabledPerAddress[NFT.contractAddress],
                  isVisible:
                    !!selectedNFTs.length &&
                    isTransferring &&
                    !approvals.loading &&
                    !approvals.data[NFT.contractAddress.toLowerCase()],
                  onClick: (): void => onApprovalClick(NFT.contractAddress),
                }}
                isApproved={approvals.data[NFT.contractAddress.toLowerCase()] === true && isTransferring}
                verified={NFT.verified}
              />
            </Fragment>
          );
        })
      ) : (
        <div className="NFT-tile nft-placeholder center">
          <h3>No NFT selected</h3>
        </div>
      )}
    </SwipableContainer>
  );
};
